<template>
  <van-popup :value="value" @input="onPopupChange" close-icon="close" closeable position="bottom"
             :close-on-click-overlay="false"
             style="background: #333333;padding-top:20px;border-radius: 10px 10px 0 0 ;">
    <div class="container">

      <div style="margin-bottom:280px;">
        <div style="text-align: center;color: white;font-weight: bold">重绑设备</div>

        <div class="send-captcha">
          <div>需要验证已绑定该设备的手机:{{ bindDeviceInfo.phone }}</div>
        </div>

        <div class="send-captcha">
          <div>请输入短信验证码</div>
          <van-button @click="sendCaptcha" :disabled="disableSendButton" size="small" type="primary"
                      color="#ed6c10">{{ buttonText }}
          </van-button>
        </div>
        <van-password-input style="margin-top:16px" v-model="captcha" :mask="false"
                            :focused="showKeyBoard"
                            @focus="showKeyBoard = true"/>
      </div>

      <van-number-keyboard v-model="captcha"
                           style="background: #333333;padding:10px"
                           :show="true"/>
    </div>
  </van-popup>
</template>

<script>
import user from "../api/user";
import {Toast} from "vant";

export default {
  name: "PopupReBindDevice",
  props: {
    value: {
      type: Boolean,
      require: true
    },
    bindDeviceInfo: {
      type: Object,
      require: true,
      default: {
        tag: '',
        phone: ''
      }

    },
  },
  data() {
    return {
      captcha: '',
      showKeyBoard: true,
      disableInput: false,
      disableSendButton: false,
      countDownId: -1,
      buttonText: "发送验证码",
      countDown: 60
    }
  },
  methods: {
    async sendCaptcha() {

      try {
        const resp = await user.sendUnBindDeviceByPhone({deviceTag: this.bindDeviceInfo.tag})
        this.$toast(resp.message)
        this.disableSendButton = true
        this.buttonText = `${this.countDown--}秒后可重新发送`
        this.countDownId = setInterval(() => {
          if (this.countDown < 1) {
            this.buttonText = "发送验证码"
            clearInterval(this.countDownId)
            this.disableSendButton = false
            return
          }
          this.buttonText = `${this.countDown--}秒后可重新发送`
        }, 1000)
      } catch (e) {
        this.disableSendButton = false
        this.buttonText = "发送验证码"
        clearInterval(this.countDownId)
      }
    },
    onPopupChange(e) {
      console.log(e)
      this.$emit('input', e)
    }
  },
  watch: {
    async captcha(val) {
      if (val.length === 6) {
        try {
          Toast.loading({message: "请稍后..."})
          const resp = await user.unBindDevice({
            deviceTag: this.bindDeviceInfo.tag,
            code: val
          })
          await this.$store.dispatch("cartridge/changeRebindStatus")
          this.$toast(resp.message)
          this.$emit('input', false)
        } catch (e) {
          this.captcha = ''
          this.$toast(e)
        }

      }
    }
  }
}
</script>


<style scoped lang="less">
.container {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  color: black;
}

.send-captcha {
  margin: 16px 16px 0 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: white;
}
</style>